export const report_control_index = ['report_control.index']
export const report_control_edit = ['report_control.edit']

export default [].concat(
    report_control_index,
    report_control_edit
)
